<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="User Type Name"
                invalid-feedback="User Type name should be filled"
                required
                v-model="$v.userTypeForm.name.$model"
                :is-valid="!$v.userTypeForm.name.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <label for="nik">Description</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.userTypeForm.description.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.userTypeForm.description.$invalid" class="invalid-feedback-custom">
                Description harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.productCategoryForm.description.$model"
                :is-valid="!$v.productCategoryForm.description.$invalid"
              /> -->
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.userTypeForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "UserType",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "User Type",
      fields: [
        { key: "name", label: "Tipe Konsumen", sorter: true },
        { key: "description", label: "Description", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      items: [],
      userTypeForm: tableInterfaces.user_type,
      isLoading: false,
      addButton: false,
      isEdit: false,
       options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    userTypeForm: {
      name: { required },
      description: {required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getUserType();
    },
    getUserType: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/user_type/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.userTypeForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.user_type) {
        tableInterfaces.user_type[i] = null;
      }
      this.userTypeForm = tableInterfaces.user_type;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/user_type/edit", this.userTypeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/user_type/add", this.userTypeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.userTypeForm.description = html
    },
  },
  
  mounted() {
    this.init();
  },
};
</script>
